import type { Logistic } from '@ztechapps/common.contract'
import type { TemplateVariables } from '@ztechapps/chat.webui'
import { buildDocumentLinkPdfUrl } from '@ztechapps/common.utils'
import { useTemplateResetPassword } from '@ztechapps/chat.webui'
import { useCreateLogisticDocumentLink } from '@ztechapps/logistic.webui'
import { appSettings } from '../../../config/app-settings'

export const useLogisticTemplateVariables = ({ logistic }: { logistic?: Logistic } = {}): TemplateVariables => {
  const { resetPassword: resetPasswordMain } = useTemplateResetPassword()
  const { mint } = useCreateLogisticDocumentLink()

  return {
    logisticPdfUrl: async () => {
      const { token } = await mint(logistic?._id ?? '')
      return buildDocumentLinkPdfUrl({ rootUrl: appSettings.AppUrl.store, token })
    },
    logistic,
    resetPassword: () => {
      return resetPasswordMain({ _id: logistic?.vendor?._id })
    },
    username: logistic?.vendor?.profile?.email,
    profileName: logistic?.vendor?.profile?.name,
    logisticNumber: logistic?.code,
  } as TemplateVariables
}
